import {
	Component,
	ChangeDetectionStrategy,
	Input,
	Output,
	EventEmitter,
} from '@angular/core';
import { ICMMSColumn } from '@shared/ui-components/au-table-layout/utils/interfaces';
import { ACTION_TYPES } from '@shared/ui-components/au-table-layout/utils/enums';
import { iconEnum } from '@app/configs/model/IconEnum';
import { MatIcon } from '@angular/material/icon';
import { OpenDtFromWorkspaceComponent } from '@app/pages/cmms/components/shared-form-group-controls/cmms-open-dt-from-workspace/open-dt-from-workspace.component';
import { ICMMSEntities } from '@app/pages/cmms/interfaces/cmms-global.interfaces';
import { MatButtonModule } from '@angular/material/button';
/*
	Important! When we have action column we must have a custom data where we have array of actions.
	Example: customData: { actions: [ACTION_TYPES.DELETE] }
 */
@Component({
	selector: 'au-table-actions-column',
	templateUrl: './au-table-actions-column.component.html',
	styleUrls: ['./au-table-actions-column.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [MatIcon, OpenDtFromWorkspaceComponent, MatButtonModule],
})
export class AuTableActionsColumnComponent {
	@Input() column: ICMMSColumn;
	@Input() data: any;
	@Output() remove = new EventEmitter<{ data: any }>();
	@Output() viewInDt = new EventEmitter<{ data: any }>();
	ACTION_TYPES = ACTION_TYPES;

	getEntityName(data: ICMMSEntities): string {
		switch (data.__typename) {
			case 'AssetObjectType':
				return 'asset';
			case 'WorkOrderObjectType':
			case 'WorkOrderType':
				return 'work_order';
			case 'IncidentObjectType':
				return 'incident';
			default:
				return undefined;
		}
	}

	getActionIcon(action: ACTION_TYPES) {
		if (action === ACTION_TYPES.UNLINK) {
			return iconEnum.remove_attachment;
		}
		if (action === ACTION_TYPES.DELETE) {
			return iconEnum.delete;
		}

		throw new Error(`
		Icon for action button not found.
		Be sure that logic for action '${action}' covered in table.
		`);
	}

	getColorActionIcon(action: ACTION_TYPES) {
		if (action === ACTION_TYPES.DELETE || action === ACTION_TYPES.UNLINK) {
			return 'critical-icon';
		}
		return '';
	}

	actionHandler(event, action: ACTION_TYPES) {
		event.stopImmediatePropagation();
		event.stopPropagation();

		if (action === ACTION_TYPES.DELETE || action === ACTION_TYPES.UNLINK) {
			this.remove.emit({ data: this.data });
		}
	}
}
